import React, { lazy, Suspense } from 'react';

const AsyncFullScreenModal = lazy(() =>
	import(/* webpackChunkName: "@atlaskit-internal_ai-full-screen-modal" */ './main').then(
		(module) => ({
			default: module.AIFullScreenModal,
		}),
	),
);

export const AIFullScreenModal = (): JSX.Element => {
	return (
		<Suspense fallback={null}>
			<AsyncFullScreenModal />
		</Suspense>
	);
};
